/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificaDto } from '../../models/notifica-dto';

export interface ApiNotificaNotificaByIdGet$Params {
    /**
     * Id della notifica da caricare
     */
    notificaId: number;
}

export function apiNotificaNotificaByIdGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiNotificaNotificaByIdGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<NotificaDto>> {
    const rb = new RequestBuilder(rootUrl, apiNotificaNotificaByIdGet.PATH, 'get');
    if (params) {
        rb.query('notificaId', params.notificaId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<NotificaDto>;
        }),
    );
}

apiNotificaNotificaByIdGet.PATH = '/api/notifica/notifica-by-id';
